import Profile from "../pages/profile";
import Users from "../pages/manageUsers/list";
import UsersForm from "../pages/manageUsers/form";

export default [
  { path: "/profile", component: Profile },
  { path: "/users", component: Users },
  { path: "/users/add", component: UsersForm },
];
